module.exports = __webpack_public_path__ + "static/media/certificate.0c9df70f.png";